import { render, staticRenderFns } from "./ClientEmailEventsContainer.vue?vue&type=template&id=6244be74&scoped=true&"
import script from "./ClientEmailEventsContainer.vue?vue&type=script&lang=js&"
export * from "./ClientEmailEventsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6244be74",
  null
  
)

export default component.exports